// src/components/UserManagement.tsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { User } from "../types/User";
import { API_BASE_URL } from "../resources/api-constants";

const UserManagement: React.FC = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [username, setUsername] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  console.log("UserManagement ${API_BASE_URL}", API_BASE_URL);

  // Fetch users on component mount
  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await axios.get<User[]>(`${API_BASE_URL}/api/public/users`); // Replace with your API URL
      console.log("UserManagement response", response);
      setUsers(response.data);
    } catch (error) {
      console.error("Failed to fetch users", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddUser = async () => {
    try {
      const newUser = { username, email };
      const response = await axios.post<User>(`${API_BASE_URL}/api/public/users`, newUser);
      setUsers([...users, response.data]);
      setUsername("");
      setEmail("");
    } catch (error) {
      console.error("Failed to add user", error);
    }
  };

  const handleDeleteUser = async (id: number) => {
    try {
      await axios.delete(`${API_BASE_URL}/api/public/users/${id}`);
      setUsers(users.filter((user) => user.id !== id));
    } catch (error) {
      console.error("Failed to delete user", error);
    }
  };



  return (
    <div>
      <h1>User Management</h1>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <div>
          <ul>
            {users.map((user) => (
              <li key={user.id}>
                <span>
                  {user.username} - {user.email}
                </span>
                <button onClick={() => handleDeleteUser(user.id)}>Delete</button>
              </li>
            ))}
          </ul>
        </div>
      )}

      <h2>Add New User</h2>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleAddUser();
        }}
      >
        <div>
          <label>
            Username:
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </label>
        </div>
        <div>
          <label>
            Email:
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
        </div>
        <button type="submit">Add User</button>
      </form>
    </div>
  );
};

export default UserManagement;
